import { createMap, FieldViewModel } from "../omnia"
import { INtrReq, Notifications } from "../types"

export function getNotifications(cropping: FieldViewModel[], requirements: INtrReq[]): Notifications {

    return {
        mismatchedCrops: getMismatchedCrops(cropping, requirements)
    }

}

function getMismatchedCrops(cropping: FieldViewModel[], requirements: INtrReq[]): FieldViewModel[] {

    const requirementsMap = createMap(
        requirements.filter(r => (!r.Zone) && (!r.PlanId)),
        r => r.CroppingId
    )

    return cropping.filter(c => {
        const r = requirementsMap.get(c.croppingId)
        return r && (r.CropId != c.cropId)
    })

}

